import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from "../../environments/environment";
import { CacheService } from '../services/cache.service';
@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.scss']
})
export class AudioPlayerComponent implements OnInit {
  public campaignConstants;
  public play = true;
  public pause = false;
  public timerMin;
  public timeSec;
  public counter = 0;
  public audio = new Audio();
  public alertClose;
  constructor(
    private route: Router,
    private authenticate: CacheService
  ) { }

  ngOnInit(): void {
    this.load()
    this.audio.addEventListener("timeupdate", (e) => {
      const { duration, currentTime } = this.audio;
      let progress = (currentTime / duration) * 100;
      document.getElementById('progress').style.width = `${progress}%`
      this.timeSec = Math.floor(currentTime);
      this.timerMin = Math.floor(this.timeSec / 60);
      this.timerMin = this.timerMin >= 10 ? this.timerMin : '0' + this.timerMin;
      this.timeSec = Math.floor(this.timeSec % 60);
      this.timeSec = this.timeSec >= 10 ? this.timeSec : '0' + this.timeSec;
    });
    this.authenticate.playMusic.subscribe((res) => {
      this.alertClose = res
      if (this.alertClose) {
        this.audio.play();
        this.play = false;
        this.pause = true;
      }
    })
    window.addEventListener('mousemove', () => {
      if (this.counter === 0) {
        this.playVideo()
        this.counter = this.counter + 1
      }
    })
    window.addEventListener('touchmove', () => {
      if (this.counter === 0) {
        this.playVideo()
        this.counter = this.counter + 1
      }
    })
  }
  async playVideo() {
    try {
      await this.audio.play();
      this.play = false;
      this.pause = true;
    } catch (err) {
      // console.log(err)
    }
  }
  load = async () => {
    const constants = await import(`../../${environment.CAMPAIGN_NAME}/constant.js`);
    this.campaignConstants = constants.default
    this.audio.src = `${environment.S3_URL_PRFIX}/track.mp3`;
    this.audio.loop = true;
    this.audio.load();
  }
  onClickPlay() {
    this.play = false;
    this.pause = true;
    this.audio.play();
  }
  onClickPause() {
    this.play = true;
    this.pause = false;
    this.audio.pause();
  }
}
